import React, { Component } from 'react';
import { every, some } from 'lodash';
import { routes } from 'constants/config';
import { Card } from 'ui/';
import request from 'utils/request_ajax';
import { getQueryParam } from 'utils/url';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Header from './Header';
import AttendanceForm from './AttendanceForm';
import AttendanceStatus from './AttendanceStatus';

class EventRegistrationOverview extends Component {
  state = {
    changingAttendance: false,
    attendance: this.props.attendance,
    statusLoading: null,
    rsvpStatus: null,
  };

  setUserAttendance = attendanceStatus => {
    const { event } = this.props;
    const { session } = this.state.attendance;
    const setAttendanceUrl = routes.IN_PERSON_TRAINING.EVENT_SET_ATTENDANCE(
      event.id,
      session.id,
    );
    const fromSharedLink =
      this.props.attendance.created_from === 'created_from_shareable_link';
    this.setState({
      statusLoading: attendanceStatus,
      rsvpStatus: attendanceStatus,
    });
    request
      .post(setAttendanceUrl, {
        status: attendanceStatus,
        shared: fromSharedLink,
      })
      .then(json => {
        this.setState({
          attendance: json.attendance,
          changingAttendance: false,
          statusLoading: null,
        });
      })
      .fail(() => {
        this.setState({
          changingAttendance: false,
          statusLoading: null,
        });
      });
  };

  changeAttendance = () => {
    this.setState({
      changingAttendance: true,
    });
  };

  displayRsvpConfirmation = () => {
    const { rsvpStatus } = this.state;

    return (
      (rsvpStatus === true && !this.state.changingAttendance) ||
      (getQueryParam(window.location.href, 'response') === 'will_attend' &&
        rsvpStatus !== false)
    );
  };

  displayRsvpRejection = () => {
    const { rsvpStatus } = this.state;

    return (
      (rsvpStatus === false && !this.state.changingAttendance) ||
      (getQueryParam(window.location.href, 'response') === 'will_not_attend' &&
        rsvpStatus !== true)
    );
  };

  render() {
    const {
      event,
      pastEvent,
      meta: { policies },
    } = this.props;
    const { changingAttendance, attendance, statusLoading } = this.state;
    const { session } = this.state.attendance;

    // User an RSVP status set
    const hasRsvpInfo = some([
      attendance.did_attend !== null,
      attendance.rsvp_status !== null,
    ]);

    // Session has a max attendance set and session is at capacity
    const sessionIsAtCapacity = every([
      session.max_attendees !== null,
      session.total_registered >= session.max_attendees,
    ]);

    // User has not registered and session is at capacity
    const showSessionAtCapacityNotice = every([
      !pastEvent || policies.canChangeAttendance,
      !(attendance.did_attend || attendance.rsvp_status === 'will_attend'),
      sessionIsAtCapacity,
    ]);

    // User has attendance status
    const hasAttendanceStatus = some([
      hasRsvpInfo && !changingAttendance,
      pastEvent && !policies.canChangeAttendance,
    ]);

    const showAttendanceStatus =
      hasAttendanceStatus || showSessionAtCapacityNotice;
    return (
      <div className="EventRegistration">
        <Header event={event} session={session} />
        <Card>
          <Card.Content padding="large">
            <div className="d-f fd-c">
              <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                {t('in_person_training.event_details')}
              </Text>
            </div>
            {this.displayRsvpConfirmation() && (
              <Text className="mt-16 d-b" variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('in_person_training.rsvp_status.confirmation_message')}
              </Text>
            )}
            <div className="mt-16">
              <SessionDetails
                session={session}
                showRegistrationCap
                eventId={event.id}
              />
            </div>
            {showAttendanceStatus && (
              <div className="mt-16">
                <AttendanceStatus
                  attendance={attendance}
                  pastEvent={pastEvent}
                  showSessionAtCapacityNotice={showSessionAtCapacityNotice}
                />
              </div>
            )}
            {this.displayRsvpRejection() && (
              <Text className="fs-i mt-16 d-b" variant={TEXT_VARIANTS.BODY}>
                {t('in_person_training.rsvp_status.will_not_attend_reminder')}
              </Text>
            )}
          </Card.Content>
          <Card.Content className="bg-gray-lightest bt-gray-lighter px-24 py-16">
            <AttendanceForm
              changeAttendance={this.changeAttendance}
              changingAttendance={changingAttendance}
              event={event}
              session={session}
              pastEvent={pastEvent}
              attendance={attendance}
              setUserAttendance={this.setUserAttendance}
              statusLoading={statusLoading}
              canChangeAttendance={policies.canChangeAttendance}
            />
          </Card.Content>
        </Card>
      </div>
    );
  }
}

export default EventRegistrationOverview;
